import React, { ReactNode } from "react";

import Layout from "../layout/layout";

interface PageProps {
  children?: ReactNode;
}

const BetaPage = ({ children }: PageProps) => {
  return <Layout>{children}</Layout>;
};

export default BetaPage;
